import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output
} from '@angular/core';
import {
    BackgroundImageModel,
    BackgroundPosition,
    BackgroundRepeat
} from './background-image.model';

@Component({
    selector: 'lib-background-image-editor',
    template: `
        <fieldset>
            <legend>Ссылка на изображение в Галерее</legend>
            <div class="source-url-editor">
                <lib-url-editor
                    class="source-url-editor__input"
                    [url]="backgroundImageModel.sourceUrl"
                    (urlChange)="patchValue({
                        sourceUrl: $event
                    })"
                    (commitChange)="commitChange.emit(backgroundImageModel)"></lib-url-editor>
                <button class="button source-url-editor__commit-button"
                    title="Подтвердить изменения"
                    (click)="commitChange.emit(backgroundImageModel)">
                    <svg width="14"
                        height="15"
                        viewBox="0 0 14 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.6317 8.71429C13.6317 8.74405 13.6287 8.76488 13.6228 8.77679C13.2418 10.372 12.4442 11.6667 11.2299 12.6607C10.0156 13.6488 8.59301 14.1429 6.96205 14.1429C6.09301 14.1429 5.25074 13.9792 4.43527 13.6518C3.62574 13.3244 2.90253 12.8571 2.26562 12.25L1.11384 13.4018C1.00074 13.5149 0.866816 13.5714 0.712054 13.5714C0.557292 13.5714 0.423363 13.5149 0.310268 13.4018C0.197173 13.2887 0.140625 13.1548 0.140625 13V9C0.140625 8.84524 0.197173 8.71131 0.310268 8.59821C0.423363 8.48512 0.557292 8.42857 0.712054 8.42857H4.71205C4.86682 8.42857 5.00074 8.48512 5.11384 8.59821C5.22693 8.71131 5.28348 8.84524 5.28348 9C5.28348 9.15476 5.22693 9.28869 5.11384 9.40179L3.89063 10.625C4.31324 11.0179 4.79241 11.3214 5.32812 11.5357C5.86384 11.75 6.42039 11.8571 6.99777 11.8571C7.79539 11.8571 8.53943 11.6637 9.22991 11.2768C9.92039 10.8899 10.474 10.3571 10.8906 9.67857C10.9561 9.57738 11.1138 9.22917 11.3638 8.63393C11.4115 8.49702 11.5007 8.42857 11.6317 8.42857H13.346C13.4234 8.42857 13.4888 8.45833 13.5424 8.51786C13.6019 8.57143 13.6317 8.6369 13.6317 8.71429ZM13.8549 1.57143V5.57143C13.8549 5.72619 13.7984 5.86012 13.6853 5.97321C13.5722 6.08631 13.4382 6.14286 13.2835 6.14286H9.28348C9.12872 6.14286 8.99479 6.08631 8.8817 5.97321C8.7686 5.86012 8.71205 5.72619 8.71205 5.57143C8.71205 5.41667 8.7686 5.28274 8.8817 5.16964L10.1138 3.9375C9.23289 3.12202 8.1942 2.71428 6.99777 2.71428C6.20015 2.71428 5.4561 2.90774 4.76562 3.29464C4.07515 3.68155 3.52158 4.21429 3.10491 4.89286C3.03943 4.99405 2.8817 5.34226 2.6317 5.9375C2.58408 6.0744 2.49479 6.14286 2.36384 6.14286H0.587054C0.509673 6.14286 0.44122 6.11607 0.381696 6.0625C0.328125 6.00298 0.301339 5.93452 0.301339 5.85714V5.79464C0.688244 4.1994 1.49182 2.90774 2.71205 1.91964C3.93229 0.925595 5.36086 0.428571 6.99777 0.428571C7.86682 0.428571 8.71205 0.595237 9.53348 0.928571C10.3549 1.25595 11.0841 1.72024 11.721 2.32143L12.8817 1.16964C12.9948 1.05655 13.1287 0.999999 13.2835 0.999999C13.4382 0.999999 13.5722 1.05655 13.6853 1.16964C13.7984 1.28274 13.8549 1.41667 13.8549 1.57143Z"
                            fill="#333333"/>
                    </svg>
                </button>
            </div>
        </fieldset>
        <fieldset>
            <legend>Повтор</legend>

            <div class="repeat-x">
                <input id="repeatXCheckbox"
                    type="checkbox"
                    [(ngModel)]="repeatX">
                <label for="repeatXCheckbox">
                    По горизонтали
                </label>
            </div>
            <div class="repeat-y">
                <input id="repeatYCheckbox"
                    type="checkbox"
                    [(ngModel)]="repeatY">
                <label for="repeatYCheckbox">
                    По вертикали
                </label>
            </div>
        </fieldset>
        <fieldset>
            <legend>Выравнивание</legend>
            <div class="button-group">
                <div class="button-group__row">
                    <button class="button button--position button--top-left"
                        [disabled]="backgroundImageModel.position === 'left top'"
                        (click)="commitBackgroundPosition('left top')">
                        <svg width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <rect x="5"
                                width="10"
                                height="6"
                                rx="1"
                                fill="#333333"/>
                            <rect x="2"
                                width="2"
                                height="16"
                                rx="1"
                                fill="#333333"/>
                        </svg>
                    </button>
                    <button class="button button--position button--top-center"
                        [disabled]="backgroundImageModel.position === 'center top'"
                        (click)="commitBackgroundPosition('center top')">
                        <svg width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <rect x="3"
                                width="10"
                                height="6"
                                rx="1"
                                fill="#333333"/>
                            <rect x="7"
                                width="2"
                                height="16"
                                rx="1"
                                fill="#333333"/>
                        </svg>
                    </button>
                    <button class="button button--position button--top-right"
                        [disabled]="backgroundImageModel.position === 'right top'"
                        (click)="commitBackgroundPosition('right top')">
                        <svg width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <rect x="2"
                                width="10"
                                height="6"
                                rx="1"
                                fill="#333333"/>
                            <rect x="13"
                                width="2"
                                height="16"
                                rx="1"
                                fill="#333333"/>
                        </svg>
                    </button>
                </div>
                <div class="button-group__row">
                    <button class="button button--position button--center-left"
                        [disabled]="backgroundImageModel.position === 'left center'"
                        (click)="commitBackgroundPosition('left center')">
                        <svg width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <rect x="5"
                                y="5"
                                width="10"
                                height="6"
                                rx="1"
                                fill="#333333"/>
                            <rect x="2"
                                width="2"
                                height="16"
                                rx="1"
                                fill="#333333"/>
                        </svg>
                    </button>
                    <button class="button button--position button--center-center"
                        [disabled]="backgroundImageModel.position === 'center center'"
                        (click)="commitBackgroundPosition('center center')">
                        <svg width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <rect x="3"
                                y="5"
                                width="10"
                                height="6"
                                rx="1"
                                fill="#333333"/>
                            <rect x="7"
                                width="2"
                                height="16"
                                rx="1"
                                fill="#333333"/>
                        </svg>
                    </button>
                    <button class="button button--position button--center-right"
                        [disabled]="backgroundImageModel.position === 'right center'"
                        (click)="commitBackgroundPosition('right center')">
                        <svg width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <rect x="2"
                                y="5"
                                width="10"
                                height="6"
                                rx="1"
                                fill="#333333"/>
                            <rect x="13"
                                width="2"
                                height="16"
                                rx="1"
                                fill="#333333"/>
                        </svg>
                    </button>
                </div>
                <div class="button-group__row">
                    <button class="button button--position button--bottom-left"
                        [disabled]="backgroundImageModel.position === 'left bottom'"
                        (click)="commitBackgroundPosition('left bottom')">
                        <svg width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <rect x="5"
                                y="10"
                                width="10"
                                height="6"
                                rx="1"
                                fill="#333333"/>
                            <rect x="2"
                                width="2"
                                height="16"
                                rx="1"
                                fill="#333333"/>
                        </svg>
                    </button>
                    <button class="button button--position button--bottom-center"
                        [disabled]="backgroundImageModel.position === 'center bottom'"
                        (click)="commitBackgroundPosition('center bottom')">
                        <svg width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <rect x="3"
                                y="10"
                                width="10"
                                height="6"
                                rx="1"
                                fill="#333333"/>
                            <rect x="7"
                                width="2"
                                height="16"
                                rx="1"
                                fill="#333333"/>
                        </svg>
                    </button>
                    <button class="button button--position button--bottom-right"
                        [disabled]="backgroundImageModel.position === 'right bottom'"
                        (click)="commitBackgroundPosition('right bottom')">
                        <svg width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <rect x="2"
                                y="10"
                                width="10"
                                height="6"
                                rx="1"
                                fill="#333333"/>
                            <rect x="13"
                                width="2"
                                height="16"
                                rx="1"
                                fill="#333333"/>
                        </svg>
                    </button>
                </div>
            </div>
        </fieldset>
    `,
    styles: [`
        .button {
            box-sizing: border-box;
            padding: 0;
            border: 1px solid #cccccc;
            background-color: #ffffff;
        }

        .button:disabled {
            background-color: #e6e6e6;
            box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
        }

        .button--position {
            width: 48px;
            height: 32px;
        }

        .button-group__row .button + .button {
            margin-left: -1px;
        }

        .button-group__row + .button-group__row {
            margin-top: -1px;
        }

        .button-group__row:first-child .button:first-child {
            border-top-left-radius: 4px;
        }

        .button-group__row:first-child .button:last-child {
            border-top-right-radius: 4px;
        }

        .button-group__row:last-child .button:first-child {
            border-bottom-left-radius: 4px;
        }

        .button-group__row:last-child .button:last-child {
            border-bottom-right-radius: 4px;
        }

        .source-url-editor {
            display: flex;
            height: 32px;
            border: 1px solid #cccccc;
            border-radius: 4px;
            overflow: hidden;
        }

        .source-url-editor__input {
            flex-grow: 1;
        }

        .source-url-editor__input ::ng-deep input {
            padding: 0 8px;
            border: 0;

            font-size: 0.875em;
            line-height: 1.35;
        }

        .source-url-editor__commit-button {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-basis: 48px;
            flex-grow: 0;
            flex-shrink: 0;
            border: 0;
            border-left: 1px solid #cccccc;
        }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackgroundImageEditorComponent {
    @Input() backgroundImageModel: BackgroundImageModel;
    @Output() backgroundImageModelChange = new EventEmitter<BackgroundImageModel>();
    @Output() commitChange = new EventEmitter<BackgroundImageModel>();

    get repeatX(): boolean {
        return this.backgroundImageModel.repeat === 'repeat'
            || this.backgroundImageModel.repeat === 'repeat-x';
    }

    set repeatX(repeatX: boolean) {
        this.patchValue({
            repeat: BackgroundImageEditorComponent.getRepeatType(repeatX, this.repeatY),
        })
        this.commitChange.emit(this.backgroundImageModel);
    }

    get repeatY(): boolean {
        return this.backgroundImageModel.repeat === 'repeat'
            || this.backgroundImageModel.repeat === 'repeat-y';
    }

    set repeatY(repeatY: boolean) {
        this.patchValue({
            repeat: BackgroundImageEditorComponent.getRepeatType(this.repeatX, repeatY),
        })
        this.commitChange.emit(this.backgroundImageModel);
    }

    static getRepeatType(repeatX: boolean, repeatY: boolean): BackgroundRepeat {
        if (repeatX && repeatY) {
            return 'repeat';
        }
        if (repeatX) {
            return 'repeat-x';
        }
        if (repeatY) {
            return 'repeat-y';
        }

        return 'no-repeat';
    }

    patchValue(changes: Partial<BackgroundImageModel>): void {
        this.backgroundImageModel = { ...this.backgroundImageModel, ...changes };
        this.backgroundImageModelChange.emit(this.backgroundImageModel);
    }

    commitBackgroundPosition(position: BackgroundPosition) {
        this.patchValue({
            position: position,
        });
        this.commitChange.emit(this.backgroundImageModel);
    }
}
